import types from '../constants';

export const setPublishing = (payload: boolean) => ({
  type: types.publish.set_publishing,
  payload: {
    is_publishing: payload,
  },
});
